module.exports = __webpack_public_path__ + "img/logo.bb166712.svg";